//
//
//
//
//
//
//

import { mapGetters } from 'vuex'

export default {
  name: 'AppHeaderBagIcon',

  computed: {
    ...mapGetters('user', ['isSubscriber']),
    ...mapGetters('cart', ['bagCount']),

    show() {
      return (
        !['recommendations', 'checkout', 'checkout-confirmation'].includes(
          this.$route.name
        ) && !this.isSubscriber
      )
    }
  }
}
